import React from 'react';
import RecipeManager from './RecipeManager';
import schema from './schemas/beverage_schema.v2_2.json';

export default function BeverageRecipeManager() {
  return <RecipeManager schema={schema} defaultRecipeType="beverage" />;
}